import React from "react";
import "./small-spinner-styles.scss";

const SmallSpinner = () => {
  return <div className="small-spinner-loader"></div>;
};

export default SmallSpinner;
